import { Link } from "react-router-dom";
import { Heart, Scale, Plus } from "lucide-react";
import { motion } from "framer-motion";
import { useShop } from "../store/ShopContext";
import { formatPrice } from "../lib/api";

export const ProductCard = ({ product, index = 0 }) => {
  const { toggleWishlist, isWishlisted, toggleCompare, isCompared, addToCart } = useShop();
  const wished = isWishlisted(product.slug);
  const compared = isCompared(product.slug);

  return (
    <motion.article
      data-testid={`product-card-${product.slug}`}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: Math.min(index * 0.06, 0.4), ease: [0.22, 1, 0.36, 1] }}
      className="group relative"
    >
      <Link to={`/produs/${product.slug}`} className="block surface aspect-[4/5] relative overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center p-8 sm:p-10">
          <img
            src={product.images[0]}
            alt={product.name}
            loading="lazy"
            className="product-img max-h-full max-w-full object-contain transition-transform duration-700 ease-out group-hover:scale-105"
          />
        </div>
        {product.badge && <span className="badge-cc absolute top-4 left-4">{product.badge}</span>}
        <div className="absolute top-3 right-3 flex flex-col gap-1 opacity-100 lg:opacity-0 lg:translate-x-2 lg:group-hover:opacity-100 lg:group-hover:translate-x-0 transition-[opacity,transform] duration-300">
          <button
            data-testid={`wishlist-toggle-${product.slug}`}
            aria-label="Favorite"
            onClick={(e) => { e.preventDefault(); toggleWishlist(product); }}
            className={`h-9 w-9 flex items-center justify-center bg-white transition-colors duration-200 hover:bg-[#0A0A0A] hover:text-white ${wished ? "text-[#0A0A0A]" : "text-[#4A4A4A]"}`}
          >
            <Heart size={16} strokeWidth={1.5} fill={wished ? "currentColor" : "none"} />
          </button>
          <button
            data-testid={`compare-toggle-${product.slug}`}
            aria-label="Compară"
            onClick={(e) => { e.preventDefault(); toggleCompare(product); }}
            className={`h-9 w-9 flex items-center justify-center transition-colors duration-200 hover:bg-[#0A0A0A] hover:text-white ${compared ? "bg-[#0A0A0A] text-white" : "bg-white text-[#4A4A4A]"}`}
          >
            <Scale size={16} strokeWidth={1.5} />
          </button>
        </div>
        <button
          data-testid={`quick-add-${product.slug}`}
          onClick={(e) => { e.preventDefault(); addToCart(product, product.color); }}
          className="absolute bottom-0 left-0 right-0 h-12 bg-[#0A0A0A] text-white text-[12px] uppercase tracking-[0.18em] font-semibold hidden lg:flex items-center justify-center gap-2 translate-y-full group-hover:translate-y-0 transition-transform duration-300"
        >
          <Plus size={14} /> Adaugă în coș
        </button>
      </Link>
      <div className="pt-4 flex items-start justify-between gap-4">
        <div>
          <p className="eyebrow">{product.collection}</p>
          <Link to={`/produs/${product.slug}`} className="block font-medium text-[15px] mt-1 leading-snug hover:text-[#B4A38E] transition-colors duration-200">
            {product.name}
          </Link>
          {product.color && <p className="text-xs text-[#737373] mt-0.5">{product.color}</p>}
        </div>
        <p data-testid={`price-${product.slug}`} className="font-semibold text-[15px] whitespace-nowrap">{formatPrice(product.price)}</p>
      </div>
    </motion.article>
  );
};
